/**
 * currentEntityId constants
 */
export const SET_CURRENT_ENTITY_ID = 'SET_CURRENT_ENTITY_ID';
